<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M2.4 0C1.8 0 1.2.3.7.7.3 1.2 0 1.8 0 2.4v7.2c0 .9.3 1.8.9 2.4-.6.7-.9 1.5-.9 2.4v6c0 1 .4 1.9 1.1 2.5.6.7 1.5 1.1 2.5 1.1h16.8c1 0 1.9-.4 2.5-1.1.7-.7 1.1-1.6 1.1-2.5v-6c0-.9-.3-1.8-.9-2.4.6-.6.9-1.5.9-2.4V2.4c0-.6-.3-1.2-.7-1.7-.5-.4-1.1-.7-1.7-.7h-6c-.3 0-.6.1-.8.4-.2.2-.4.5-.4.8v.1c0 .6-.2 1.2-.7 1.6-.4.4-1 .7-1.6.7h-.2c-.6 0-1.2-.2-1.6-.7s-.7-1-.7-1.6v-.1c0-.3-.1-.6-.4-.8C9 .1 8.7 0 8.4 0h-6zm1.2 10.8h16.8c.3 0 .6-.1.8-.4.2-.2.4-.5.4-.8V2.4h-4.9c-.2 1-.8 1.9-1.7 2.6-.8.7-1.8 1-2.9 1h-.2C10.8 6 9.8 5.6 9 5c-.8-.7-1.4-1.6-1.7-2.6H2.4v7.2c0 .3.1.6.4.8.2.3.5.4.8.4zm10.8 2.4H9.6v.1c0 1.3 1 2.3 2.3 2.3h.2c.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.6v-.1zm-7.2 0H3.6c-.3 0-.6.1-.8.4-.2.2-.4.5-.4.8v6c0 .3.1.6.4.8.2.2.5.4.8.4h16.8c.3 0 .6-.1.8-.4s.4-.5.4-.8v-6c0-.3-.1-.6-.4-.8-.2-.2-.5-.4-.8-.4h-3.6v.1c0 1.2-.5 2.4-1.4 3.3-.9.9-2.1 1.4-3.3 1.4h-.2c-1.2 0-2.4-.5-3.3-1.4-.9-.9-1.4-2.1-1.4-3.3v-.1z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
</template>
